import { SurfaceConstants, VisibleTime } from 'owa-calendar-surface-core';
import { CalendarSurfaceStore } from 'owa-calendar-surface-dategrid';
import { differenceInMinutes, now, today } from 'owa-datetime';
import { isDateInDateRange } from 'owa-datetime-utils';

/**
 * This function calculates scroll top offset for surface day/week view based on today and working hours configuration
 * Scrolls to current time if day is in range. Otherwise scrolls to working hours.
 * @param {CalendarSurfaceStore} store - the calendar surface store
 * @returns scroll position for for current range
 */
export default function calculateScrollOffset(store: CalendarSurfaceStore): number {
    const currentDay = today();
    return isDateInDateRange(store.dateRange, currentDay)
        ? getScrollTop(store, differenceInMinutes(now(), currentDay))
        : getScrollTop(store, store.userOptions.workHoursStartTimeInMinutes);
}

function getScrollTop(store: VisibleTime, offsetInMinutes: number): number {
    return Math.ceil(offsetInMinutes) - store.dayStartMinute - SurfaceConstants.scrollTopAdjustment;
}
